import { render, staticRenderFns } from "./BaseHeaderDropDownFilter.vue?vue&type=template&id=5f98044c&scoped=true&lang=pug"
import script from "./BaseHeaderDropDownFilter.vue?vue&type=script&lang=ts"
export * from "./BaseHeaderDropDownFilter.vue?vue&type=script&lang=ts"
import style0 from "./BaseHeaderDropDownFilter.vue?vue&type=style&index=0&id=5f98044c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f98044c",
  null
  
)

export default component.exports